import { useState, useRef, useEffect } from 'react';
import { Card, Row, Col, Divider, Typography,Flex, Grid, Modal } from 'antd';
const { Title } = Typography;

// 修改类型定义，添加 height 字段
type RadiationPoint = [lng: number, lat: number, radius: number, city: string, height: number];

import mapimg from '@/assets/images/map0425.png';
import servicelocation from '@/assets/icons/service-location.svg';
import servicespare from '@/assets/icons/service-spare.svg';
import flagchina from '@/assets/icons/flag-china.svg';
import flagjapan from '@/assets/icons/flag-japan.svg';
import flaguk from '@/assets/icons/flag-uk.svg';
import flagsingapore from '@/assets/icons/flag-sing.svg';

const { useBreakpoint } = Grid;

// 添加CSS样式
const modalStyles = `
  .city-modal .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
    padding: 0;
    box-shadow: 0 8px 32px rgba(0,0,0,0.12);
  }
  
  .city-modal .ant-modal-header {
    background: linear-gradient(135deg, #e37456 0%, #f66f14 100%);
    border-bottom: none;
    padding: 20px 24px;
  }
  
  .city-modal .ant-modal-title {
    color: white !important;
  }
  
  .city-modal .ant-modal-close {
    color: white;
    top: 0px;
    right: 0px;
  }
  
  .city-modal .ant-modal-close:hover {
    background-color: rgba(255,255,255,0.1);
  }
  
  .city-tag {
    animation: fadeInUp 0.3s ease-out;
    animation-fill-mode: both;
  }
  
  .city-tag:nth-child(1) { animation-delay: 0.1s; }
  .city-tag:nth-child(2) { animation-delay: 0.15s; }
  .city-tag:nth-child(3) { animation-delay: 0.2s; }
  .city-tag:nth-child(4) { animation-delay: 0.25s; }
  .city-tag:nth-child(5) { animation-delay: 0.3s; }
  .city-tag:nth-child(6) { animation-delay: 0.35s; }
  .city-tag:nth-child(7) { animation-delay: 0.4s; }
  .city-tag:nth-child(8) { animation-delay: 0.45s; }
  .city-tag:nth-child(9) { animation-delay: 0.5s; }
  .city-tag:nth-child(10) { animation-delay: 0.55s; }
  .city-tag:nth-child(11) { animation-delay: 0.6s; }
  .city-tag:nth-child(12) { animation-delay: 0.65s; }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .province-ellipse:hover {
    cursor: pointer;
  }
  
  .province-ellipse:active {
    fill: rgba(227, 116, 86, 0.2) !important;
  }
`;

const SVGMap = () => {
  // 模拟辐射点数据，添加不同的 height 值
  const [points] = useState<RadiationPoint[]>([
    [42.8, -22, 70, '北京', 80],
    [35, -60, 50, '深圳', 70],
    [59.0, -41.5, 70, '上海', 90],
    [70.5, -58, 80, '台湾', 60],
    [126, -28.5, 65, '日本', 100],
    [-173.5, -32, 60, '英国', 30],
    [-6.8, -79.3, 55, '新加坡', 85],
  ]);

  // 坐标转换函数
  const project = (lng: number, lat: number): [number, number] => {
    return [
      ((lng + 180) / 360) * 1000,
      ((90 - lat) / 180) * 1000
    ];
  };

  const svgRef = useRef<SVGSVGElement>(null);
  const [isMobile, setIsMobile] = useState(false);

  // 检测是否为移动设备
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  //销售城市
  const provinceCityMap: Record<string, string[]> = {
    '大湾区': ['深圳', '广州', '香港', '清远', '惠州', '东莞', '顺德', '珠海'],
    '江浙沪': ['上海','杭州', '南京', '苏州', '无锡', '扬州','嘉兴', '宁波', '舟山', '昆山', '滁州'],
    '山东': ['青岛', '潍坊', '烟台'],
    '江西': ['南昌', '吉安'],
    '湖北': ['武汉', '鄂州', '恩施', '宜昌', '荆州', '襄阳'],
    '湖南': ['长沙', '永州', '株洲'],
    '陕西': ['西安', '咸阳'],
    '河南': ['郑州', '洛阳'],
    '川渝地区': ['成都', '重庆'],
    '京津冀地区': ['北京','天津','石家庄','保定', '廊坊'],
    '安徽': ['合肥', '芜湖', '宣城'],
    '福建': ['福州', '厦门', '泉州'],
    '东北地区': ['哈尔滨','长春','大连','锦州'],
    '广西': ['南宁'],
    '东南亚': ['新加坡', '马来西亚', '越南', '泰国'],
  };

  const [hoveredProvince, setHoveredProvince] = useState<string | null>(null);
  const [mousePos, setMousePos] = useState<{x: number, y: number}>({x: 0, y: 0});
  const [isModalVisible, setIsModalVisible] = useState(false);
  
  // 获取所有销售据点
  const allSalesPoints = Object.values(provinceCityMap).flat();
  
  const provinceAreas: Record<string, {cx: number, cy: number, rx: number, ry: number}> = {
    '京津冀地区': { cx: 620, cy: 620, rx: 28, ry: 30 },
    '江浙沪': { cx: 660, cy: 730, rx: 20, ry: 45 },
    '大湾区': { cx: 590, cy: 830, rx: 30, ry: 20 },
    '陕西': { cx: 530, cy: 690, rx: 18, ry: 42 },
    '湖南': { cx: 565, cy: 770, rx: 20, ry: 28 },
    '湖北': { cx: 580, cy: 740, rx: 30, ry: 15 },
    '江西': { cx: 610, cy: 780, rx: 15, ry: 28 },
    '山东': { cx: 640, cy: 670, rx: 28, ry: 15 },
    '安徽': { cx: 625, cy: 730, rx: 18, ry: 20 },
    '福建': { cx: 640, cy: 800, rx: 18, ry: 30 },
    '东北地区': { cx: 710, cy: 560, rx: 78, ry: 80 },
    '川渝地区': { cx: 480, cy: 740, rx: 58, ry: 28 },
    '河南': { cx: 590, cy: 700, rx: 38, ry: 20 },
    '广西': { cx: 520, cy: 830, rx: 28, ry: 18 },
    '东南亚': { cx: 470, cy: 880, rx: 45, ry: 50 },
  };

  // 处理省份点击事件（只在移动端）
  const handleProvinceClick = () => {
    if (isMobile) {
      setIsModalVisible(true);
    }
  };

  // 关闭弹窗
  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <style>{modalStyles}</style>
      <svg 
        ref={svgRef}
        viewBox="0 0 1000 1000"
        style={{ 
          width: '100%', 
          height: '100%', 
          position: 'absolute',
          bottom: 0,
          left: 0,
        }}
      >
        {/* 辐射点 */}
        {points.map(([lng, lat, radius], index) => {
          const [x, y] = project(lng, lat);
          return (
            <g key={index} transform={`translate(${x},${y})`}>
              <circle r={radius} fill="url(#radial-gradient)">
                <animate
                  attributeName="r"
                  from={radius * 0.2}
                  to={radius * 1.2}
                  dur="3s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="opacity"
                  from="0.8"
                  to="0"
                  dur="3s"
                  repeatCount="indefinite"
                />
              </circle>
              <circle r={4} fill="#f66f14" />
            </g>
          );
        })}

        {/* 渐变定义 */}
        <defs>
          <radialGradient id="radial-gradient">
            <stop offset="0%" stopColor="#e37456" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#e37456" stopOpacity="0" />
          </radialGradient>
          {/* 添加蓝色光柱渐变 */}
          <radialGradient id="beam-radial-gradient" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#e37456" stopOpacity="0.8" />
            <stop offset="50%" stopColor="#e37456" stopOpacity="0.4" />
            <stop offset="100%" stopColor="#e37456" stopOpacity="0" />
          </radialGradient>
          {/* 添加垂直光柱渐变 */}
          <linearGradient id="vertical-beam-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#e37456" stopOpacity="0.9" />
            <stop offset="50%" stopColor="#e37456" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#e37456" stopOpacity="0" />
          </linearGradient>
          {/* 添加光晕效果 */}
          <filter id="glow">
            <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>

        {/* 省份区域 */}
        {Object.entries(provinceAreas).map(([province, area]) => (
          <ellipse
            key={province}
            cx={area.cx}
            cy={area.cy}
            rx={area.rx}
            ry={area.ry}
            fill={hoveredProvince === province ? "transparent" : "transparent"}
            onMouseEnter={e => {
              if (!isMobile) {
                setHoveredProvince(province);
                setMousePos({ x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY });
              }
            }}
            onMouseMove={e => {
              if (!isMobile) {
                setMousePos({ x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY });
              }
            }}
            onMouseLeave={() => {
              if (!isMobile) {
                setHoveredProvince(null);
              }
            }}
            onClick={handleProvinceClick}
            className="province-ellipse"
            style={{ 
              cursor: isMobile ? 'pointer' : 'default', 
              transition: 'all 0.3s ease' 
            }}
          />
        ))}

        {/* PC端弹窗 */}
        {hoveredProvince && !isMobile && (
          <foreignObject
            x={mousePos.x - 200}
            y={mousePos.y - 10}
            width={300}
            height={(provinceCityMap[hoveredProvince]?.length || 0) * 28 + 68}
            style={{ pointerEvents: 'none' }}
          >
            <div style={{
              background: 'rgba(255,255,255,0.98)',
              borderRadius: 12,
              boxShadow: '0 4px 18px rgba(0,0,0,0.18)',
              padding: 18,
              fontSize: 15,
              color: '#333',
              minWidth: 120,
              border: '2px solid #e37456',
              fontFamily: 'PingFang SC, sans-serif',
              animation: 'fadeIn 0.2s'
            }}>
              <b style={{ color: '#e37456', fontSize: 17 }}>{hoveredProvince}</b>
              <div style={{ marginTop: 10, display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {provinceCityMap[hoveredProvince]?.map(city => (
                  <span key={city} style={{
                    background: '#f6e7e0',
                    color: '#e37456',
                    borderRadius: 8,
                    padding: '4px 12px',
                    fontWeight: 500,
                    fontSize: 15,
                    marginBottom: 4,
                    boxShadow: '0 1px 4px rgba(227,116,86,0.08)'
                  }}>{city}</span>
                ))}
              </div>
            </div>
          </foreignObject>
        )}
      </svg>

      {/* 移动端弹窗 - 显示所有销售据点 */}
      <Modal
        title={
          <div style={{ 
            color: 'white', 
            fontSize: '18px', 
            fontWeight: 'bold',
            textAlign: 'center',
            fontFamily: 'PingFang SC, sans-serif'
          }}>
            销售服务城市
          </div>
        }
        open={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
        centered
        width="90%"
        className="city-modal"
        style={{ maxWidth: '500px' }}
        styles={{
          body: {
          padding: '20px',
          maxHeight: '70vh',
          overflowY: 'auto'
        }}}
      >
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '12px',
          justifyContent: 'center'
        }}>
          {allSalesPoints.map(city => (
            <span 
              key={city} 
              className="city-tag"
              style={{
                background: '#f6e7e0',
                color: '#e37456',
                borderRadius: '12px',
                padding: '8px 16px',
                fontWeight: '500',
                fontSize: '16px',
                boxShadow: '0 2px 8px rgba(227,116,86,0.15)',
                border: '1px solid #e37456',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
            >
              {city}
            </span>
          ))}
        </div>
        <div style={{
          marginTop: '20px',
          textAlign: 'center',
          color: '#666',
          fontSize: '14px',
          fontFamily: 'PingFang SC, sans-serif'
        }}>
          共 {allSalesPoints.length} 个销售服务城市
        </div>
      </Modal>
    </>
  );
};

const SalesCoverageMap: React.FC = () => {
  const screens = useBreakpoint();
  return (
    <div>
      <div className='' style={{ maxWidth: '1490px', margin: '0 auto'}}>
        <div>
          <Divider className='divider-text'>
          <span style={{fontFamily: 'PingFang SC, sans-serif' }}>Global NetWork</span>
          </Divider>
          <Title className='text-center text-primary' level={2}>
            全球服务覆盖布局
          </Title>
          <p className='text-center text-info pl-10 pr-10' style={{maxWidth: '1000px', margin: '0 auto',whiteSpace: 'pre-line'}}>
            {screens.md? 'EETL在深圳、香港、上海、北京、日本、英国、新加坡、中国台湾等地设有销售据点\n服务网络当前已覆盖中国、日本、泰国、新加坡、马来西亚、越南、中国台湾等地区，为客户提供高效、可靠的供应链支持。' 
            : 'EETL在深圳、香港、上海、北京、日本、英国、新加坡、中国台湾等地设有销售据点'}
          </p>
        </div>
        <div>
          <div className='position-relative' style={{marginTop: '-17%'}}>
            <img src={mapimg} className='w-100' alt='Global Coverage Map' />
            <SVGMap />
          </div>
          <div className='container'>
          <div className='mt-30 p-20'>
              <Row gutter={[48, 24]}>
                <Col span={24} md={13} lg={13}>
                  <Card className='card-map'>
                    <Flex className='' align='center'>
                      <img width={40} src={servicelocation} alt="Trophy" />
                      <div className='ml-10'>
                      <b style={{ fontSize: '1.25rem' }}>销售据点</b>
                      </div>
                    </Flex>
                    <div className='mt-20'>
                      {screens.md ? (
                        <Flex justify='center'>
                          <div className='text-center'>
                            <span style={{fontSize: '3rem'}}>8+</span>
                            <div className='text-info'>
                              全球销售网点
                            </div>
                          </div>
                          <div className='mt-20 text-center mb-10' 
                          style={{borderLeft: '1px solid #dedede',padding: '0 20px',borderRight: '1px solid #dedede',margin: '0 20px'}}>
                            <img width={40} src={flagchina} alt="中国" />
                            <Flex className='text-info' style={{marginTop: '23px'}} gap={8}>
                              <span>深圳</span>
                              <span>香港</span>
                              <span>上海</span>
                              <span>北京</span>
                              <span>台湾</span>
                            </Flex>
                          </div>
                          <div className='mt-20 text-center pl-20 pr-20'>
                            <img className='mr-15' width={40} src={flagjapan} alt="日本" />
                            <img className='mr-15' width={40} src={flaguk} alt="英国" />
                            <img className='mr-15' width={40} src={flagsingapore} alt="新加坡" />
                            <Flex className='text-info' justify='center' style={{marginTop: '23px'}} gap={8}>
                              <span>日本</span>
                              <span>英国</span>
                              <span>新加坡</span>
                            </Flex>
                          </div>
                        </Flex>
                      ): ( 
                        <Flex justify='center'>
                          <div className='text-center'>
                            <span style={{fontSize: '3rem'}}>8+</span>
                            <div className='text-info'>
                              全球销售网点
                            </div>
                          </div>
                          <div className='pl-20 ml-20' style={{borderLeft: '1px solid #dedede'}}>
                            <Flex className='mt-20 text-center mb-10'>
                              <img className='mr-15' width={40} src={flagchina} alt="中国" />
                              <img className='mr-15' width={40} src={flagjapan} alt="日本" />
                              <img className='mr-15' width={40} src={flaguk} alt="英国" />
                              <img className='mr-15' width={40} src={flagsingapore} alt="新加坡" />
                              
                            </Flex>
                            <Flex className='text-info' gap={8}>
                              <span>深圳</span>
                              <span>香港</span>
                              <span>上海</span>
                              <span>北京</span>
                              <span>台湾</span>
                            </Flex>
                            <Flex className='text-info' gap={8}>
                              <span>日本</span>
                              <span>英国</span>
                              <span>新加坡</span>
                            </Flex>
                          </div>
                        </Flex>
                      )}
                    </div>
                  </Card>
                </Col>
                <Col span={24} md={11} lg={11}>
                  <Card className='card-map h-100'>
                    <Flex className='' align='center'>
                      <div>
                        <Flex className='' align='center'>
                          <img width={40} src={servicespare} alt="服务网络" />
                          <div className='ml-10'>
                          <b style={{ fontSize: '1.25rem' }}>服务网络</b>
                          </div>
                        </Flex>
                        <Flex className='mt-20' justify='center' align='center'>
                          <div className='text-center'>
                            <span style={{fontSize: '2.75rem'}}>300+</span>
                            <div className='text-info'>
                              全球服务网络
                            </div>
                          </div>
                          <div className='ml-20' 
                        style={{borderLeft: '1px solid #dedede',padding: '0 20px'}}>
                          
                            <div className='text-info'>
                              服务网络当前已覆盖中国、日本、泰国、新加坡、马来西亚、越南、中国台湾等地区300多个城市，为客户提供高效、可靠的供应链支持。
                            </div>
                          </div>
                        </Flex>
                      </div>
                    </Flex>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesCoverageMap;
